import React from 'react'
import { LocalStore } from '../storage/authStore';

const checkRole = (role) => {
    const loggedUser = LocalStore.getLoggedUserDetails();
  if(loggedUser?.role?.title === role){
    return true;
  }
  return false;
}

export default checkRole
